import React,{useState, useEffect} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle, EntryAuditInfo} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { formatDateOnly } from '../../../common/functions';
import Grid from "@material-ui/core/Grid";
import { ItemCard } from '../../../components';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableBody';
import {useGlobalState} from '../../../state';
import PaymentIcon from "@material-ui/icons/Payment";
import { isAutoGeneratedPurchase, AUTO_PURCHASE_MESSAGE } from './autoGenerated';
import DialogActions from '@material-ui/core/DialogActions';

const useStyles = makeStyles(theme => ({
    fields: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.primary.default,
    },
    totalTable: {
        float: 'right',
        width: theme.spacing(28.6)
    },
    totalCell: {
        width: theme.spacing(14.5),
        paddingLeft: theme.spacing(0)
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    deleteButton: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
}));

const PurchaseDetails = ({ data, handlePurchaseDetailsDialogClose, showPurchaseDetailsDialog,onPaymentEdit,
    onPurchaseEdit, onDelete }) => {
    const classes = useStyles();
    const [{user}] = useGlobalState();
    // Staff can only change purchases created today
    const canModify = !(data && user.role === "STAFF" && !moment(data.createTime).isSame(moment(), "date"));
    // Read-only instead of disabled so the values stay readable
    const readOnly = { readOnly: true };
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
      const [billValue, setBillValue] = useState(0);
      const [tdsValue, setTdsValue] = useState(0)
      const [tcsValue, setTcsValue] = useState(0)
      const [gstValue, setGstValue] = useState(0)
      const [finalTotal, setFinalTotal] = useState(0)

    /* const [billValueSum, setBillValueSum] = useState(0.0)
 
     function calculateBillTotal() {
         let total = 0.0
         let billValue = 0.0
         if(data !== undefined && data !== null && data.purchaseMaterials !== undefined && data.purchaseMaterials !== null){
             data.purchaseMaterials.forEach((purchaseMaterial,index)=>{
                 if (purchaseMaterial.weightType === 1){
                     billValue = (purchaseMaterial.billWeight*purchaseMaterial.costPerUnit)+(purchaseMaterial.billWeight*purchaseMaterial.costPerUnit*(data.tax/100))
                 }else{
                     billValue = (purchaseMaterial.deliveryWeight*purchaseMaterial.costPerUnit)+(purchaseMaterial.deliveryWeight*purchaseMaterial.costPerUnit*(data.tax/100))
                 }
 
                 total = total + billValue
             })
         }
         setBillValueSum(total)
     }
 
     useEffect(calculateBillTotal, [data]);
 */

     useEffect(() => {
        if (data && data.purchaseMaterials && Array.isArray(data.purchaseMaterials) && (data.purchaseMaterials).length > 0) {
            calculateValues(data)
        }
     }, [data])

    function calculateValues(data){
        let billAmt = 0
        let tdsAmt = 0
        let tcsAmt = 0
        let gstAmt = 0
        let purchaseMaterials = data.purchaseMaterials 
        if(purchaseMaterials !== undefined){
            purchaseMaterials.forEach((purchaseMaterial) => {
                billAmt += purchaseMaterial.billValue
                let  commissionAmount  = 0
                if (purchaseMaterial.commissionPerUnit > 0) {
                    if (purchaseMaterial.weightType === 1) {
                        commissionAmount = (purchaseMaterial.billWeight * (purchaseMaterial.commissionPerUnit));
                    } else {
                        commissionAmount = (purchaseMaterial.deliveryWeight *  ( purchaseMaterial.commissionPerUnit));
                    }
                }
                let taxableTotal  = purchaseMaterial.billValue - commissionAmount
                let tdsTaxAmt = taxableTotal * ((data.tds ? data.tds : 0)) / 100
                let tcsTaxAmt = taxableTotal * ((data.tcs ? data.tcs : 0)) / 100
                let gstTaxAmt = taxableTotal * ((purchaseMaterial.gst ? purchaseMaterial.gst : 0)) / 100
                tdsAmt += tdsTaxAmt
                tcsAmt += tcsTaxAmt
                gstAmt += gstTaxAmt
            })
        }
        let gstTCSVal = gstAmt * (data.tcs/100)
        let totalTCS = Math.ceil(tcsAmt + gstTCSVal)
        let total = billAmt - tdsAmt + totalTCS + gstAmt
        setBillValue(billAmt)
        setTdsValue(tdsAmt)
        setTcsValue(totalTCS)
        setGstValue(gstAmt)
        setFinalTotal(total)
    }

    // Same card layout as the material lines in the purchase edit dialog
    const getMaterialCardData = (material) => {
        const commPerUnit = material.commissionPerUnit > 0 ? material.commissionPerUnit : 0;
        let taxMultiplier = 1;
        if (data.tax < 0) taxMultiplier = 1 + data.tax / 100;
        const weight = material.weightType === 1 ? (material.billWeight || 0) : (material.deliveryWeight || 0);
        const lineValue = weight * ((material.costPerUnit || 0) + commPerUnit) * taxMultiplier;
        const gstAmt = ((material.gst || 0) / 100) * (material.billValue || 0);

        const items = [
            { name: 'Bill wt', value: material.billWeight || 0 },
            { name: 'Delivery wt', value: material.deliveryWeight || 0 },
            { name: 'Cost / unit', value: (material.costPerUnit || 0).toLocaleString(user.locales, amountObj) },
            { name: 'Commission', value: commPerUnit.toLocaleString(user.locales, amountObj) },
        ];
        if (gstAmt > 0) items.push({ name: 'GST', value: gstAmt.toLocaleString(user.locales, amountObj) });
        items.push({ name: 'Line value', value: lineValue.toLocaleString(user.locales, amountObj), highlight: true });

        const descParts = [material.weightType === 1 ? 'Bill Weight' : 'Delivery Weight'];
        if (material.inventoryType === 1) {
            descParts.push('Feed Mill');
        } else {
            const farmName = material.farmName?.String || '';
            const shedName = material.shedName?.String || '';
            if (farmName || shedName) descParts.push(`${farmName} · ${shedName}`);
        }

        return { items, description: descParts.join(' · ') };
    };

    return data ? <Dialog maxWidth='md' open={showPurchaseDetailsDialog} onClose={handlePurchaseDetailsDialogClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title">Purchase Details
        {handlePurchaseDetailsDialogClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={handlePurchaseDetailsDialogClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
        <DialogContent dividers  >
            {isAutoGeneratedPurchase(data) &&
                <Typography color="textSecondary" className={classes.fields}>{AUTO_PURCHASE_MESSAGE}</Typography>}
            <div className={`grid-container ${classes.fields}`}>
                <TextField label="Date" value={formatDateOnly(data.date, "DD/MM/YYYY")} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField label="Bill Number" value={data.billNumber || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField label="Truck Number" value={data.truckNumber || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField label="Payment Due (in Days)" value={data.paymentDueDate || ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}} />
                <TextField select label="Vendor Name" value={data.vendorName ? 0 : ''} InputProps={readOnly} variant="outlined" style={{backgroundColor:"#ffffff"}}>
                    <MenuItem value={0}>{data.vendorName}</MenuItem>
                </TextField>
            </div>
            <Grid>
                {!data.purchaseMaterials || data.purchaseMaterials.length === 0
                    ? <ItemCard emptyMessage="No material lines" />
                    : data.purchaseMaterials.map((material, idx) => {
                        const { items, description } = getMaterialCardData(material);
                        return (
                            <ItemCard
                                key={material.id || idx}
                                title={material.materialName}
                                description={description}
                                items={items}
                            />
                        );
                    })
                }
                <Table className={classes.totalTable} >
                    <TableHead>
                    <TableRow>
                        <TableCell className={classes.totalCell}>Bill Value</TableCell>
                        <TableCell>{(billValue).toLocaleString(user.locales,amountObj)}</TableCell>
                    </TableRow>
                    {/* commenting for now */}
                    {gstValue && gstValue > 0 ? 
                        <TableRow>
                        <TableCell className={classes.totalCell}>GST</TableCell>
                        <TableCell>{(gstValue).toLocaleString(user.locales,amountObj)}</TableCell>
                    </TableRow>
                    : null}
                    {tdsValue && tdsValue > 0 ? <TableRow>
                        <TableCell className={classes.totalCell}>TDS </TableCell>
                        <TableCell>{(tdsValue).toLocaleString(user.locales,amountObj)}</TableCell>
                    </TableRow> : null}
                    {tcsValue && tcsValue > 0 ? <TableRow>
                        <TableCell className={classes.totalCell}  >TCS </TableCell>
                        <TableCell>{(tcsValue).toLocaleString(user.locales,amountObj)}</TableCell>
                    </TableRow>: null}
                    
                    <TableRow>
                        <TableCell className={classes.totalCell} >Final Total </TableCell>
                        <TableCell>{(finalTotal).toLocaleString(user.locales,amountObj)}</TableCell>
                    </TableRow>
                    {/* commenting for now */}
                    {/* <TableRow>
                        <TableCell className={classes.totalCell}  >Total with TDS </TableCell>
                        <TableCell>                        
                        {
                        data.totalBillValue === 0 ?
                        (0).toLocaleString(user.locales,amountObj): 
                        (data.totalBillValue-(((data.tds || 0)*data.totalBillValue)/100)).toLocaleString(user.locales,amountObj)
                        }
                        </TableCell>
                    </TableRow> */}
                    </TableHead>
                </Table>
            </Grid>
        </DialogContent>
        
            {canModify &&
            <DialogActions>
                <EntryAuditInfo entry={data}/>
                {/* <div className={classes.actions}> */}
                    <Button variant="outlined" color="secondary" startIcon={<PaymentIcon />} onClick={() => onPaymentEdit(data)}>
                        Payment
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<EditIcon />} onClick={() => onPurchaseEdit(data)}>
                        Edit
                    </Button>
                    <Button variant="outlined" className={classes.deleteButton} startIcon={<DeleteIcon />} onClick={() => onDelete(data)}>
                        Delete
                    </Button>
                {/* </div> */}
                </DialogActions>
            }
    </Dialog>
        : null
};

export default PurchaseDetails;